import React from 'react';
import { useTheme } from '../../context/ThemeContext';

interface FailurePopupProps {
  message: string;
  isOpen: boolean;
  onClose: () => void;
}

export const FailurePopup: React.FC<FailurePopupProps> = ({ message, isOpen, onClose }) => {
  const { theme } = useTheme();
  
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex items-center justify-center z-50 modal-backdrop">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full modal-content">
        <div className="flex items-center justify-center mb-4">
          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
            <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </div>
        </div>
        
        <h2 className="text-xl font-bold text-center mb-2">Verification Failed</h2>
        <p className="text-gray-600 text-center mb-6">{message}</p>
        
        <div className="flex justify-center">
          <button 
            onClick={onClose}
            className={`px-6 py-2 rounded-md text-white button-hover ${theme["button-bg"]}`}
          >
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
};
